import React from "react";
import { ChartData } from "../Shared/ProfileData/ChartData";
import { ChartDisplay, ChartDisplayProps } from "./ChartDisplay";
import { GetClasses } from "./CSSPicker";

export type AboutPanelProps = {
    charts : ChartData[];
    width : number;
    height : number;
    regionName : string;
    idPrefix : string;
    valuePostfixes : string[];
}

export const AboutPanel = ({charts, width, height, idPrefix, regionName, valuePostfixes} : AboutPanelProps) : React.JSX.Element => {

    charts.splice(3);

    const titleHeight = 50;


    const chartWidth = width / 2;
    const xc = [0,0,chartWidth];
    const yc = [0,(height-titleHeight)/2, 0];
    const hc = [(height- titleHeight)/2, (height-titleHeight)/2, height-titleHeight];



    return (
        <div style={{display : "flex" ,
             flexDirection : "column" ,
              minWidth : width + "px",
              maxWidth : width + "px",
            width : width + "px",
            minHeight : height + "px",
            maxHeight : height + "px",
            height : height + "px",
            backgroundColor : "black",
        }}>
            <span style={{ fontFamily : "Roboto", fontSize : "25px", color : "white", fontWeight : 700 }}>About the fans this week in {regionName}</span>
            <svg id={idPrefix + "SVG"} width={width} height={height-titleHeight}>
            {
                charts.map((chart : ChartData, index : number)=> {
                    const reverse = index ==1;
                    const props : ChartDisplayProps = {
                        chartData : chart,
                        x : xc[index],
                        y : yc[index],
                        width : chartWidth,
                        height : hc[index],
                        options : {
                            showAxis : false,
                            barCSS : chart.chartType === "bar" ? GetClasses(3,'hover', reverse) : chart.chartType==="line" ? GetClasses(1,'hover'): GetClasses(10,'LowLight', reverse),
                            barHighlightCSS : ['AboutChartsBarHighlight1'],
                            axisColor : 'black',
                            bottomLabelSpace : 90,
                            yCalculator : 'variation',
                            yCalcParameter : 2.0,
                            valuePostfix : valuePostfixes[index],
                            textHeight : 14,
                            xmin : 0,
                            xmax : 1,
                            isDate : false,
                            idPrefix: idPrefix + "Chart" + index + "_", 
                            barWidth : 0.5,
                            
                        }
                    }
                    return <ChartDisplay key={'AboutPanelChart' + index} {...props}/>
                })
            }
            </svg>
        </div>
    );
    
} 